<template>
    <div class="head">
        <div class="company">
            <a href="/"><img v-bind:src="setting.app_logo_dark"
                    alt="Xpansion Technologies" /></a>
            <p class="text-white mt-1 mb-0 p-0"><b>ABN</b> {{setting.abn}}</p>
        </div>
        <div class="client text-white" v-if="client">
          <img v-bind:src="client.picture" class="logo" v-bind:alt="client.company_name" />
        </div>
    </div>
</template>
<script>
export default {
  name: 'base-header',
  props: ['client'],
  data () {
    return {
      setting: []
    }
  },
  mounted () {
    fetch('https://xtservicedesk.com/api/v1/setting')
      .then((res) => res.json())
      .then((result) => {
        this.setting = result.data
      })
  }
}
</script>
